import React, { forwardRef, useContext } from "react";
import { useTranslation } from "react-i18next";
import useLanguage from "../../utils/useLanguage";
import { UserAuth } from "../../utils/AuthContext";

const PaperInvoicePrintComponent = forwardRef(
  (
    { invoiceData, invoiceDetails, customerData, creatorDetails, currency },
    ref
  ) => {
    const { t } = useTranslation("general");
    const { currentDirection } = useLanguage();
    const { userData } = useContext(UserAuth);
    const userType = localStorage.getItem("userType");

    return (
      <div ref={ref} className="paper-invoice-container" dir={currentDirection}>
        {/* Compact Header */}
        <div className="paper-invoice-header">
          <h2 className="paper-invoice-title">
            {userData?.organizationName || userData?.username}
          </h2>
          <div className="u-width_full-width o-row o-row--gap-size_300 o-row--horizontal-align_center u-padding--right_200 u-padding--left_200">
            <div>
              <span>{t("address")}: </span>
              <span>{localStorage.getItem("address")}</span>
            </div>
            <div>
              <span>{t("phoneNumber")}: </span>
              <span>
                {userType == "organization"
                  ? localStorage.getItem("orgPhoneNumber")
                  : localStorage.getItem("phoneNumber")}
              </span>
            </div>
          </div>
          <h4 className="paper-invoice-label">{t("sellInvoice")}</h4>
        </div>

        <div>
          {/* User Info Bar */}
          <div className="paper-invoice-info-bar">
            <div>
              <span>{t("user")}:</span> {localStorage.getItem("username")}
            </div>
            <div>
              <span>{t("printDate")}:</span> {new Date().toLocaleDateString()}
            </div>
          </div>

          {/* Compact Invoice and Customer Info */}
          <div className="paper-invoice-grid">
            {/* Invoice Info */}
            <div className="o-row o-row--gap-size_700">
              <div className="o-column o-column--gap-size_200">
                <span className="paper-invoice-label">
                  {t("invoiceNumber")}:
                </span>
                <span className="paper-invoice-label">{t("Date")}:</span>
                <span className="paper-invoice-label">{t("creator")}:</span>
              </div>
              <div className="o-column o-column--gap-size_200">
                <span className="paper-invoice-value">
                  {invoiceDetails?.invoiceNumber}
                </span>
                <span className="paper-invoice-value">
                  {invoiceDetails?.invoiceDate}
                </span>
                <span className="paper-invoice-value">
                  {creatorDetails?.name || t("undefined")}
                </span>
              </div>
            </div>

            <div className="o-row o-row--gap-size_700">
              <div className="o-column o-column--gap-size_200">
                {customerData.customerName ? (
                  <>
                    <span className="paper-invoice-label">
                      {t("customerName")}:
                    </span>
                    <span className="paper-invoice-label">
                      {t("phoneNumber")}:
                    </span>
                    <span className="paper-invoice-label">{t("address")}:</span>
                  </>
                ) : null}
              </div>
              <div className="o-column o-column--gap-size_200">
                <span className="paper-invoice-value">
                  {customerData?.customerName}
                </span>
                <span className="paper-invoice-value">
                  {customerData?.phoneNumber}
                </span>
                <span className="paper-invoice-value">
                  {customerData?.address}
                </span>
              </div>
            </div>
          </div>

          {/* Product Table */}
          <h3 className="paper-invoice-section-title">{t("orderInfo")}</h3>

          {invoiceData && invoiceData.length > 0 ? (
            <div className="paper-invoice-table">
              <div className="paper-invoice-table-header">
                <span className={`paper-invoice-cell `}>
                  {t("categoryName")}
                </span>
                <span className="paper-invoice-cell">{t("amountOfRolls")}</span>
                <span className="paper-invoice-cell">{t("dimension")}</span>
                <span className="paper-invoice-cell">
                  {t("paperThickness")}
                </span>
                <span className="paper-invoice-cell">{t("quantity")}</span>
                <span className="paper-invoice-cell">{t("price")}</span>
                <span className="paper-invoice-cell">{t("totalAmount")}</span>
              </div>
              {invoiceData.map((item, index) =>
                item[0]?.value !== null ? (
                  <div key={index} className="paper-invoice-table-row">
                    <span className={`paper-invoice-cell font-medium `}>
                      {item[0]?.value || "-"}
                    </span>
                    <span className="paper-invoice-cell">
                      {item[1]?.value || "-"}
                    </span>
                    <span className="paper-invoice-cell font-mono">
                      {item[2]?.value || "-"}
                    </span>
                    <span className="paper-invoice-cell font-mono">
                      {item[3]?.value || "-"}
                    </span>
                    <span className="paper-invoice-cell font-medium">
                      {item[4]?.value || "-"}
                    </span>
                    <span
                      className={`paper-invoice-cell font-semibold text-green `}
                    >
                      {item[5]?.value || "-"}
                    </span>
                    <span
                      className={`paper-invoice-cell font-semibold text-green `}
                    >
                      {item[6]?.value || "-"}
                    </span>
                  </div>
                ) : null
              )}
            </div>
          ) : (
            <div className="paper-invoice-empty-state">{t("noDetails")}</div>
          )}

          {/* {invoiceDetails} */}

          <h3 className="paper-invoice-section-title">{t("invoiceSummary")}</h3>
          {invoiceDetails?.invoiceAmount ? (
            <div className="paper-invoice-amount-summary">
              <div className="paper-invoice-amount-grid">
                <div className="paper-invoice-amount-row">
                  <span className="paper-invoice-amount-label">
                    {t("totalPrice")}:
                  </span>
                  <span className="paper-invoice-amount-value">
                    {invoiceDetails?.invoiceAmount?.totalPrice || 0}{" "}
                    {currency.value}
                  </span>
                </div>
                <div className="paper-invoice-amount-row">
                  <span className="paper-invoice-amount-label">
                    {t("discount")}:
                  </span>
                  <span className="paper-invoice-amount-value discount">
                    -{invoiceDetails?.invoiceAmount.discount || 0}{" "}
                    {currency.value}
                  </span>
                </div>
                <div className="paper-invoice-amount-row separator">
                  <span className="paper-invoice-amount-label final">
                    {t("finalAmount")}:
                  </span>
                  <span className="paper-invoice-amount-value final">
                    {invoiceDetails?.invoiceAmount.finalAmount || 0}{" "}
                    {currency.value}
                  </span>
                </div>
                <div className="paper-invoice-amount-row">
                  <span className="paper-invoice-amount-label">
                    {t("receivedAmount")}:
                  </span>
                  <span className="paper-invoice-amount-value received">
                    {invoiceDetails?.invoiceAmount.receivedAmount || 0}{" "}
                    {currency.value}
                  </span>
                </div>
                <div className="paper-invoice-amount-row">
                  <span className="paper-invoice-amount-label">
                    {t("leftAmount")}:
                  </span>
                  <span className="paper-invoice-amount-value left">
                    {invoiceDetails?.invoiceAmount.leftAmount || 0}{" "}
                    {currency.value}
                  </span>
                </div>
              </div>
            </div>
          ) : null}

          {/* Notes Section */}
          {invoiceDetails?.invoiceNote && (
            <div className="paper-invoice-notes">
              <h3 className="paper-invoice-notes-title">
                <span className="paper-invoice-icon">i</span>
                {t("notes")}
              </h3>
              <p className="paper-invoice-text">
                {invoiceDetails?.invoiceNote}
              </p>
            </div>
          )}
        </div>

        {/* Elegant Footer */}
        <div className="paper-invoice-footer">
          <p className="paper-invoice-footer-title">
            {t("ehsiblySecondSlogan")}
          </p>
          <p className="paper-invoice-footer-subtitle">{t("alhabbarSlogan")}</p>
        </div>
      </div>
    );
  }
);

PaperInvoicePrintComponent.displayName = "PaperInvoicePrintComponent";

export default PaperInvoicePrintComponent;
